<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-12 09:41:48
 * @LastEditTime: 2025-12-31 11:37:22
 * @LastEditors: 刘小二
 * @Description  : 风控复审
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/supplyManagement/overdueSupplyReviewApproval.vue
-->
<template>
    <div class="flows-content">
        <el-container>
            <el-main style="margin-bottom: 20px; padding: 0;">
                <el-container direction="vertical">
                    <FlowHeader :isReadOnly="readOnly" :saveStatus="false" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
                        @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
                        @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
                        @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
                    <el-main class="info">
                        <div>
                            <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                                placeholder="请输入流程标题"></el-input>
                        </div>
                        <div class="info-top">
                            <div class="left">
                                <span>单据号码：{{ billCode }}</span>
                                <span class="text">制单日期：{{ billDate }}</span>
                            </div>
                            <div class="right">
                                <span>发起人：{{ applyPerson }}</span>
                                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
                            </div>
                        </div>
                        <div style="margin-top:20px;" class="table">
                            <div class="tabtop" style="width: 380px">
                                <div v-for="(item, index) in dataTypeList" :key="index" @click="choose(item.status)">
                                    <div :class="tableParam.whetherControl == item.status ? 'active' : 'text'">{{ item.value }}</div>
                                </div>
                            </div>
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%;margin-top: 12px;"  :data="tableData" tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '是否风控'">
                                                <el-select v-model="scope.row.whetherControl"
                                                    :disabled="approvalStatus != 0 || approvalStatus != 4"
                                                    style="width: 180px" clearable
                                                    @change="e => updateControl(e, scope.row.id)">
                                                    <el-option label="是" :value="1"></el-option>
                                                    <el-option label="否" :value="0"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item.label == '偏差率X（%）'">
                                               {{decimal.mul(scope.row.deviationRateX || 0,100) + '%'}}
                                            </span>
                                            <span v-else-if="item.label == '本期项目产值(万元)'">
                                                {{ decimal.div(scope.row.currentProjectOutputValue*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期合同应收款(万元)'">
                                                {{ decimal.div(scope.row.currentContractReceivables*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期累计回款(万元)'">
                                                {{ decimal.div(scope.row.currentCumulativePaymentReceived*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期工程欠款(万元)'">
                                                {{ decimal.div(scope.row.currentEngineeringArrears*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期合同欠款(万元)'">
                                                {{ decimal.div(scope.row.currentContractArrears*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '上期合同应收款(万元)'">
                                                {{ decimal.div(scope.row.lastContractReceivables*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '实时累计回款(万元)'">
                                                {{ decimal.div(scope.row.realTimeCumulativeReal*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '欠款管控等级'">
                                                <span v-if="scope.row.debtControlLevel == 0">不管控</span>
                                                <span v-if="scope.row.debtControlLevel == 1">等级一</span>
                                                <span v-if="scope.row.debtControlLevel == 2">等级二</span>
                                                <span v-if="scope.row.debtControlLevel == 3">等级三</span>
                                                <span v-if="scope.row.debtControlLevel == 4">等级四</span>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <div class="card_bottom">
                                <div class="card_bottom_left">
                                    <div class="top_page_totle">总共{{ total }}条</div>
                                    <!-- <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                                        layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange"
                                        @current-change="overdueSupplyDetailQueryPage()"></el-pagination> -->
                                </div>
                                <div>
                                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                                        @click="overdueSupplyDetailQueryPage">刷新</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="flows-details">
                            <FlowContent ref="flowcontent" :title='title' :dataForm="formData" :urlType="1" :showSendVisible="showSendVisible"
                                @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish"
                                @handleBusiness="handleBusiness" @resetFlowState="resetFlowState" />
                        </div>
                    </el-main>
                </el-container>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { safeDecodeURI } from "@/utils/utils.js";
import { backlogQueryByReceiptNumber } from '@/api/index';
import { overdueSupplyDetailQueryPage2,examineApprove,overdueSupplyCallback } from "@/api/internetSales/supplyManagement.js";
export default {
    components: {
        FlowContent,
        FlowHeader,
    },
    data() {
        return {
            type: 0,
            title: '欠供复审单',
            billCode: '',
            billDate: '',
            taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
            applyPerson: '',
            taskStatus: 0,
            showSendVisible: false,
            readOnly: false,
            table: [
                { label: "日期", prop: "dataMouth", status: true, width: "80", fixed: "left", },
                { label: "财务编码", prop: "financialCode", status: true, width: "220", fixed: "left", },
                { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left", },
                { label: "合同单位", prop: "contractUnit", status: true, width: "220" },
                { label: "施工进度", prop: "constructionProgress", status: true, width: "auto" },
                { label: "本期项目产值(万元)", prop: "currentProjectOutputValue", status: true, width: "100" },
                { label: "本期合同应收款(万元)", prop: "currentContractReceivables", status: true, width: "110" },
                { label: "本期累计回款(万元)", prop: "currentCumulativePaymentReceived", status: true, width: "100" },
                { label: "本期工程欠款(万元)", prop: "currentEngineeringArrears", status: true, width: "100" },
                { label: "本期合同欠款(万元)", prop: "currentContractArrears", status: true, width: "100" },
                { label: "上期合同应收款(万元)", prop: "lastContractReceivables", status: true, width: "100" },
                { label: "实时累计回款(万元)", prop: "realTimeCumulativeReal", status: true, width: "100" },
                { label: "偏差率X（%）", prop: "deviationRateX", status: true, width: "auto" },
                { label: "合同欠款绝对额Y", prop: "contractArrearsAbsValue", status: true, width: "auto" },
                { label: "欠款管控等级", prop: "debtControlLevel", status: true, width: "auto" },
            ],
            formData: {},
            tableData: [],
            total: 0,
            tableParam: {
                engineeringName: "",
                reviewId: "",
                whetherControl: 1,
            },
            dataTypeList: [
                {
                    value: "管控列表",
                    status: 1,
                },
                {
                    value: "不管控列表",
                    status: 0,
                },
            ],
        }
    },
    methods: {
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.overdueSupplyDetailQueryPage();
        },
        overdueSupplyDetailQueryPage() {
            overdueSupplyDetailQueryPage2(this.tableParam).then(res => {
                if (res.code == 1001) {
                    this.tableData = res.data
                    this.total = res.data.length
                }
            })
        },
        choose(num) {
            this.tableParam.whetherControl = num
            this.overdueSupplyDetailQueryPage()
        },
         //1 不通过  2撤销
        resetFlowState(type) {
            if (type == 1) {
                const params = {
                    process_success: {
                        url: '/icps/system/sign/cloudSell/overdueSupply/approveCallback',
                        data: {
                            id: this.formData.id,
                            approvalStatus: 1,
                        },
                        httpMethod: 'post',
                    },
                    process_failure: {
                        url: '/icps/system/sign/cloudSell/overdueSupply/approveCallback',
                        data: {
                            id: this.formData.id,
                            approvalStatus: 4,
                        },
                        httpMethod: 'post',
                    },
                }
                this.$refs.flowcontent.handleToFlow(params);
            } else if (type == 2) {
                overdueSupplyCallback({
                    id: this.formData.id,
                    approvalStatus: 4,
                })
            }
            this.showSendVisible = false;
        },
        handleBusiness() {
            const params = {
                process_success: {
                    url: '/icps/system/sign/cloudSell/overdueSupply/approveCallback',
                    data: {
                        id: this.formData.id,
                        approvalStatus: 1,
                    },
                    httpMethod: 'post',
                },
                process_failure: {
                    url: '/icps/system/sign/cloudSell/overdueSupply/approveCallback',
                    data: {
                        id: this.formData.id,
                        approvalStatus: 4,
                    },
                    httpMethod: 'post',
                },
            }
            // const params = {
            //   process_success: {
            //     url: '/icps/surplus/save',
            //     data:{
            //       engineeringName:this.formData.engineeringName,
            //       engineeringId:this.formData.engineeringId,
            //       startTime:this.formData.startTime,
            //       endTime:this.formData.endTime,
            //       approveStatus:2,
            //       id:this.formData.id,
            //     },
            //     httpMethod: 'post',
            //   },
            //   process_failure: {
            //   url: '/icps/surplus/save',
            //   data:{
            //       engineeringName:this.formData.engineeringName,
            //       engineeringId:this.formData.engineeringId,
            //       startTime:this.formData.startTime,
            //       endTime:this.formData.endTime,
            //       approveStatus:3,
            //       id:this.formData.id,
            //   },
            //   httpMethod: 'post',
            //  }
            // }
            this.showSendVisible = false;
            console.log('--------------')
            console.log(params)
            console.log('++++++++++++++++')
            this.$refs.flowcontent.handleToFlow(params);
        },
        /**
         * @Description: 
         * @Param: 1为保存，2为最后提交/3 中间提交 status 为2 通过 为3不通过
         * @Author: wangwangwang
         * @param {*} type
         */
        handleFinish(type, status) {
            console.log(type, status)
            if(type == 1) {
                examineApprove({id:this.formData.id})
            }
        },
        handleSubmit(type) {
            const { query } = this.$route;
            if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 提交流程
                this.showSendVisible = true;
                return
            }
            const data = {
                dataSource: 'overdueSupplyReviewApproval',
                dataContent: JSON.stringify({ ...this.formData }), // 业务数据
            }
            this.$refs.flowcontent.saveFlows(type, data);
        },
        handleCancel() {
            this.showSendVisible = false;
        },
        /**
         * @Description: 回显业务数据
         * @Param: 
         * @Author: wangwangwang
         */
        initFlowsData() {
            this.isReadOnly = true;
            const { query } = this.$route;
            console.log("initFlowsData2", query);
            // const { formData} = query;
            const data = safeDecodeURI(JSON.parse(query.dataContent));
            console.log("dataContent", data);
            this.formData = data;
            this.tableParam.reviewId = this.formData.id
            this.overdueSupplyDetailQueryPage()
        },
        initFlowsData2() {
            const { query } = this.$route;
            // alert(JSON.stringify(query))
            this.formData = safeDecodeURI(JSON.parse(query.dataContent));
            this.formData.surplusDate = this.formData.startTime + "-" + this.formData.endTime
            this.title = query.taskName;
            this.billCode = query.receiptNumber;
            this.applyPerson = query.createUserName;
            this.billDate = query.createTime;
            this.taskStatus = query.taskStatus;
            this.tableParam.reviewId = this.formData.id
            this.overdueSupplyDetailQueryPage()
            this.openWorkFlowInfo()
        },
        sendCode(code) {
            this.billCode = code;
        },
        handleFlowChat() {
            this.$refs.flowcontent.showFlowNode()
        },
        // 查看审批情况
        openWorkFlowInfo(){
            console.log('查看审批情况 ',this.billCode)
            if(this.billCode){
                backlogQueryByReceiptNumber(this.billCode).then(res=>{
                    if(res.code == 1001){
                        if(res.data){
                            let valData = res.data
                            this.taskStatus = valData.taskStatus
                            this.applyPerson = valData.createUserName
                            this.billDate = valData.createTime
                            if(this.taskStatus == 3 || this.taskStatus == 4 || this.taskStatus == 5){
                                this.readOnly = true
                            }
                        }
                    }
                })
            }
        },
    },
    mounted() {
        const { query } = this.$route;
        if (query.type == 1) {
            // 发起流程
            this.initFlowsData();
            this.applyPerson = getUserInfo().userRealName;
            this.$refs.flowcontent.initBaseData("overdueSupplyReviewApproval");
            this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
            this.formData.createUserName = this.applyPerson;
            this.formData.createTime = this.billDate;
            this.title = '欠供复审单-' +  this.formData.dataMouth
            return;
        }
        this.initFlowsData2();
        if (query.isReadOnly * 1 === 1) {
            this.readOnly = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.flows-details {
    margin-top: 20px;
}

.info {
    padding: 0 20px;
    background: #fff;

    .info-top {
        font-size: $font_size;
        color: #000000;
        @include discen_al;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px #e1e5ed solid;

        .left {
            @include discen_al;
        }

        .text {
            margin-left: 60px;
        }
    }
}

.nav_title {
    @include discen_al;
    align-items: flex-end;

    >div {
        width: 4px;
        height: 24px;
        background: $bg_color;
        margin-right: 10px;
    }

    i {
        margin-left: 5px;
    }

    color: $bg_color;
    font-size: 20px;
    font-weight: bold;
}
</style>